    <app-indicadores [dashBoardId]="3">
    </app-indicadores>